import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Post } from "../../models/post.model";

@Injectable()
export class PostProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Post> {
    return this.http
      .get<Post>(`${this.url}/posts/${id}`)
      .map(response => {
        return new Post(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Post[]> {
    return this.http
      .get<Post[]>(`${this.url}/posts`)
      .map(response => {
        return response.map((post) => new Post(post));
      })
      .catch(this.handleError);
  }

  liked(id: number): Observable<Post> {
    return this.http
      .post<Post>(`${this.url}/posts/like`, { 'post_id' : id})
      .map(response => {
        return new Post(response);
      })
      .catch(this.handleError)
  }

  shared(id: number): Observable<Post> {
    return this.http
      .post<Post>(`${this.url}/posts/share`, { 'post_id' : id})
      .map(response => {
        return new Post(response);
      })
      .catch(this.handleError)
  }

}



// WEBPACK FOOTER //
// ./src/providers/post/post.ts